<div
  class="header-wrapper"
  [class.logged-in]="isLoggedIn"
  [class.custom-border-left]="isCollapsed && isLoggedIn"
>
    @if (viewAdvertisement) {
    <div class="advertisement" >
        <div class="close" (click)="closeAd()" tabindex="0" (keydown.enter)="closeAd()" role="button" aria-label="Cerrar anuncio">
          <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M12 4L4 12" stroke="#011F0E" stroke-linecap="round" stroke-linejoin="round"/>
            <path d="M4 4L12 12" stroke="#011F0E" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
        </div>
        <div class="content-image">
            <img src="/header/imagen banner.png" alt="Header Ads">
        </div>
        <div class="content-banner">
            <div class="badge_title" >
                Vuélvete Promotor de Ribera del Rio
                <div class="content_logo">
                    <div class="circle-white">
                        <img src="/header/png/Ribera_logo_white.svg" alt="Ribera del Rio" class="logo" />
                    </div>
                </div>
            </div>
            <lib-ribera-default-btn
            [borderRadius]="'10px'"
            variant="primary"
            size="small"
            (press)="logout()"
            >Registrarme</lib-ribera-default-btn
            >
        </div>
    </div>
    }
  <div class="header-container">
    <div class="logo-section">
      <a
        (click)="navigateToHome()"
        (keydown.enter)="navigateToHome()"
        tabindex="0"
        role="button"
        aria-label="Ir al inicio"
        style="cursor: pointer; display: inline-block; text-decoration: none"
      >
        <img
          src="/header/png/Ribera_logo.svg"
          alt="Ribera del Rio"
          class="logo"
        />
      </a>
    </div>

    <div class="spacer"></div>

    <!-- NAVBAR DESKTOP PARA NO LOGUEADO -->
    @if (!isLoggedIn) {
    <nav class="desktop-navbar">
      <a class="nav-link" routerLink="/test-about">Nosotros</a>
      <a class="nav-link" routerLink="/test-contact">Contacto</a>

      <div
        class="nav-dropdown"
        (mouseenter)="openDropdown('alojamiento')"
        (mouseleave)="closeDropdown('alojamiento')"
      >
        <a class="nav-link dropdown-trigger" routerLink="/bookings">
          Alojamiento
          <i class="pi pi-angle-down"></i>
        </a>
        @if (activeDropdown === 'alojamiento') {
        <div class="dropdown-menu">
          <a class="dropdown-item" routerLink="/bookings">Departamento</a>
          <a
            class="dropdown-item"
            routerLink="/bookings"
            (click)="setFilterRooms()"
            >Habitaciones</a
          >
        </div>
        }
      </div>

      <div
        class="nav-dropdown"
        (mouseenter)="openDropdown('servicios')"
        (mouseleave)="closeDropdown('servicios')"
      >
        <a class="nav-link dropdown-trigger" routerLink="/services">
          Servicios
          <i class="pi pi-angle-down"></i>
        </a>
        @if (activeDropdown === 'servicios') {
        <div class="dropdown-menu">
          <a class="dropdown-item" routerLink="/services/restaurant"
            >Restaurante</a
          >
          <a class="dropdown-item" routerLink="/services/experiences"
            >Experiencias</a
          >
          <a class="dropdown-item" routerLink="/services/fullday">Fullday</a>
          <a class="dropdown-item" routerLink="/services/events">Eventos</a>
        </div>
        }
      </div>

      <a class="nav-link" routerLink="/promotions">Promociones</a>

      <a class="nav-link nav-login" (click)="goToLoginAsPromoter()" tabindex="0" (keydown.enter)="goToLoginAsPromoter()">
        Iniciar sesión
      </a>

      <button class="btn-reservar" (click)="navigateToBookings()">
        Reservar
      </button>
    </nav>
    }

    <div class="right-section">
      <span class="current-date">{{ currentDate | date:'d MMM yyyy' }}</span>

      <img
        src="/header/png/calendar-2.svg"
        alt="Calendar"
        class="icon calendar-icon"
      />
      <span
        class="pi pi-user"
        style="font-size: 22px; color: #011f0e; cursor: pointer"
        (click)="goToLogin()"
        role="button"
        tabindex="0"
        (keydown.enter)="goToLogin()"
        aria-label="Ir al login"
      ></span>

      <button
        class="menu-toggle-btn"
        (click)="toggleMenu()"
        aria-label="Toggle menu"
      >
        <img [src]="menuIcon" alt="Menu" class="icon icon-menu" />
      </button>
    </div>
    <!-- DESKTOP HEADER: visible solo en desktop cuando está logueado -->
    @if (isLoggedIn) {
    <div class="desktop-header">
      <div class="header-center">
        <nav class="breadcrumb">
          <span class="breadcrumb-icon"
            ><img
              src="https://ribera.s3.us-east-1.amazonaws.com/ribera-web-2.0/home/navbar/Icon.svg"
              alt="Inicio"
          /></span>
          <span class="breadcrumb-item">Inicio</span>
          <span class="breadcrumb-separator">&gt;</span>
        </nav>
      </div>
      <div class="header-right">
        <div class="page-title page-title-right">Página Web</div>
        <button class="back-btn" aria-label="Volver">
          <img
            src="https://ribera.s3.us-east-1.amazonaws.com/ribera-web-2.0/home/navbar/undo.svg"
            alt="Volver"
            style="width: 32px; height: 32px"
          />
        </button>
        <button class="notification-btn" aria-label="Notificaciones">
          <img
            src="https://ribera.s3.us-east-1.amazonaws.com/ribera-web-2.0/home/navbar/Search.svg"
            alt="Buscar"
            style="width: 40px; height: 40px"
          />
        </button>
      </div>
    </div>
    }
  </div>

  <!-- BARRA DE INFORMACIÓN DEBAJO DEL NAVBAR (fuera del container) -->
  @if (!isLoggedIn) {
  <div class="info-bar">
    <div class="social-icons">
      <a
        href="https://www.instagram.com/riberadelrio.club/"
        target="_blank"
        rel="noopener"
        aria-label="Instagram"
      >
        <img
          src="https://ribera.s3.us-east-1.amazonaws.com/ribera-web-2.0/home/icons/ig.svg"
          alt="Instagram"
        />
      </a>
      <a
        href="https://www.tiktok.com/@clubriberadelrio"
        target="_blank"
        rel="noopener"
        aria-label="TikTok"
      >
        <img
          src="https://ribera.s3.us-east-1.amazonaws.com/ribera-web-2.0/home/icons/tiktok.svg"
          alt="TikTok"
        />
      </a>
      <a
        href="https://wa.me/51938627411"
        target="_blank"
        rel="noopener"
        aria-label="WhatsApp"
      >
        <img
          src="https://ribera.s3.us-east-1.amazonaws.com/ribera-web-2.0/home/icons/wsp.svg"
          alt="WhatsApp"
        />
      </a>
      <a
        href="https://www.facebook.com/RiberaDelRioClubResort/?locale=es_LA"
        target="_blank"
        rel="noopener"
        aria-label="Facebook"
      >
        <img
          src="https://ribera.s3.us-east-1.amazonaws.com/ribera-web-2.0/home/icons/fb.svg"
          alt="Facebook"
        />
      </a>
    </div>
    <div class="info-text">
      <span class="location">
        <img
          src="https://ribera.s3.us-east-1.amazonaws.com/ribera-web-2.0/home/icons/Vector.svg"
          alt="Ubicación"
        />
        Km 29.5 Carretera Cieneguilla - Perú
      </span>
      <a class="promotor-link" (click)="navigateToRiberaWeb()" tabindex="0" (keydown.enter)="navigateToRiberaWeb()">
        <img
          src="https://ribera.s3.us-east-1.amazonaws.com/ribera-web-2.0/home/icons/export.svg"
          alt="Promotor"
        />
        Web Ribera
      </a>
    </div>
  </div>
  } @if(menuVisible) {
  <div class="mobile-menu-overlay" [class.no-advertisement]="!viewAdvertisement">
    <div
      class="backdrop"
      role="button"
      tabindex="0"
      (click)="toggleMenu()"
      (keydown.enter)="toggleMenu()"
      aria-label="Cerrar menú"
    ></div>

    <div class="menu-content-box">
      @if (isLoggedIn) {
      <div class="profile-row">
        <img [src]="avatarUrl" alt="Avatar" class="avatar" />
        <div class="profile-info">
          <span class="greeting">Buenos días</span>
          <span class="name">{{ loggedUserName }}</span>
        </div>
      </div>
      <hr class="separator" />
      }
      <nav class="nav-links">
        <a class="nav-item" routerLink="/test-about" (click)="closeMenu()">
          Nosotros
        </a>
        <a class="nav-item" routerLink="/test-contact" (click)="closeMenu()">
          Contacto
        </a>

        <div class="nav-item-wrapper" [class.open]="bookingsSubmenuOpen">
          <a
            class="nav-item has-submenu"
            routerLink="/bookings"
            (click)="closeMenu()"
          >
            Alojamientos
          </a>
          <button
            class="submenu-toggle"
            (click)="toggleBookingSubmenu($event)"
            aria-label="Abrir Submenú de servicios"
          >
            <i
              [class]="bookingsSubmenuOpen ? 'pi pi-angle-up' : 'pi pi-angle-down'"
            ></i>
          </button>
        </div>

        @if (bookingsSubmenuOpen) {
        <div class="submenu">
          <a class="submenu-item" routerLink="/bookings" (click)="closeMenu()">
            Departamento
          </a>
          <a
            class="submenu-item"
            routerLink="/bookings"
            (click)="setFilterRooms()"
          >
            Habitaciones
          </a>
        </div>
        }

        <div class="nav-item-wrapper" [class.open]="servicesSubmenuOpen">
          <a
            class="nav-item has-submenu"
            routerLink="/services"
            (click)="closeMenu()"
          >
            Servicios
          </a>
          <button
            class="submenu-toggle"
            (click)="toggleServiceSubmenu($event)"
            aria-label="Abrir Submenú de servicios"
          >
            <i
              [class]="servicesSubmenuOpen ? 'pi pi-angle-up' : 'pi pi-angle-down'"
            ></i>
          </button>
        </div>

        @if (servicesSubmenuOpen) {
        <div class="submenu">
          <a
            class="submenu-item"
            routerLink="/services/restaurant"
            (click)="closeMenu()"
          >
            Restaurante
          </a>
          <a
            class="submenu-item"
            routerLink="/services/experiences"
            (click)="closeMenu()"
          >
            Experiencias
          </a>
          <a
            class="submenu-item"
            routerLink="/services/fullday"
            (click)="closeMenu()"
          >
            Fullday
          </a>
          <a
            class="submenu-item"
            routerLink="/services/events"
            (click)="closeMenu()"
          >
            Eventos
          </a>
        </div>
        }

        <div class="nav-item">
          <a
            routerLink="/promotions"
            (click)="closeMenu()"
            style="text-decoration: none; color: #28353a"
            >Promociones</a
          >
        </div>
      </nav>

      <div class="menu-footer">
        <div class="info-row">
          <img
            src="/header/navbar/sms-tracking.svg"
            alt="Email"
            class="icon email-icon"
          />
          <span>atencionalcliente@cieneguillariberadelrio.com</span>
        </div>
        <div class="info-row">
          <img
            src="/header/navbar/vuesax.svg"
            alt="Whatsapp"
            class="icon whatsapp-icon"
          />
          <span>+51 938 627 411</span>
        </div>
        <div class="info-row">
          <img
            src="/header/navbar/export.svg"
            alt="Promotor"
            class="icon promotor-icon"
          />
          <a class="promotor-link"  (click)="navigateToRiberaWeb()" tabindex="0" (keydown.enter)="navigateToRiberaWeb()">Ribera Web</a>
        </div>
        @if (isLoggedIn) {
        <lib-ribera-default-btn
          icon="header/navbar/login.svg"
          variant="outline"
          size="large"
          (press)="logout()"
          >Cerrar sesión</lib-ribera-default-btn
        >
        <lib-ribera-default-btn
          icon="header/navbar/login-promotor.svg"
          size="large"
          (press)="goToLoginAsInclub(); closeMenu()"
          >Iniciar sesión como Socio</lib-ribera-default-btn
        >
        } @else {
        <lib-ribera-default-btn
          icon="header/navbar/login-promotor.svg"
          size="large"
          (press)="goToLoginAsInclub(); closeMenu()"
          >Iniciar sesión como Socio</lib-ribera-default-btn
        >
        <lib-ribera-default-btn
          icon="header/navbar/login.svg"
          variant="outline"
          size="large"
          (press)="goToLoginAsPromoter(); closeMenu()"
          >Iniciar sesión</lib-ribera-default-btn
        >
        }
      </div>
    </div>
  </div>
  }
</div>
